import { useEffect, useState } from "react";
import { fetchMaterials } from "./service";
import { Option, SearchInput } from "../product/style";
import { Spinner } from "reactstrap";
import { CoreContainer, Notification } from "./style";
import { isBrowser } from "react-device-detect";
import DataTable from "react-data-table-component";

const PricingPage = () => {
  const [type, setType] = useState("boards");
  const [materials, setMaterials] = useState(null);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState({ type: "", message: "" });
  const [isNotificationVisible, setIsNotificationVisible] = useState(false);
  const list = ["boards", "laminates", "factory"];
  const formatPrice = (price, unit) =>
    unit ? `₹${price} / ${unit}` : `₹${price}`;
  const columns = {
    boards: [
      {
        name: "Name",
        selector: (row) => row.name,
        wrap: true,
      },
      {
        name: "Price",
        selector: (row) => row.price,
        format: (row) => formatPrice(row.price, row.unit),
        width: "100px",
      },
    ],
    laminates: [
      {
        name: "Name",
        selector: (row) => row.name,
        wrap: true,
      },
      {
        name: "Price",
        selector: (row) => row.price,
        format: (row) => formatPrice(row.price),
        width: "100px",
      },
    ],
    factory: [
      {
        name: "Name",
        selector: (row) => row.name,
        wrap: true,
      },
      {
        name: "Economy",
        selector: (row) => row.economy,
        format: (row) =>
          formatPrice(row.economy, row.unit == "sq.ft." ? null : row.unit),
        width: "75px",
        compact: true,
        center: true,
      },
      {
        name: "Standard",
        selector: (row) => row.standard,
        format: (row) =>
          formatPrice(row.standard, row.unit == "sq.ft." ? null : row.unit),
        width: "75px",
        compact: true,
        center: true,
      },
      {
        name: "Premium",
        selector: (row) => row.premium,
        format: (row) =>
          formatPrice(row.premium, row.unit == "sq.ft." ? null : row.unit),
        width: "75px",
        compact: true,
        center: true,
      },
    ],
  };

  const getMaterials = () => {
    setIsLoading(true);
    setIsNotificationVisible(false);
    fetchMaterials(type)
      .then((res) => {
        setMaterials(res);
        setData(res);
      })
      .catch((error) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error.error });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getMaterials();
  }, [type]);

  const search = (event) => {
    setData(
      materials.filter((obj) =>
        obj.name.toLowerCase().includes(event.target.value.trim().toLowerCase())
      )
    );
  };

  return (
    <div className="mx-sm-5 mx-3 my-3">
      <div className="d-flex justify-content-between">
        <h2 className="mb-3 fw-bold">Pricing</h2>
      </div>
      <div className="d-flex justify-content-between mb-3 gap-3 flex-wrap">
        <div className="rounded-1 btn-group me-3">
          {list.map((e, index) => (
            <Option
              key={index}
              onClick={() => setType(list[index])}
              className={`default-option text-capitalize ${
                type === list[index] ? "selected-option" : ""
              }`}
            >
              {list[index]}
            </Option>
          ))}
        </div>
        {type !== "factory" && (
          <SearchInput
            onChange={(event) => search(event)}
            style={{ width: "300px" }}
            placeholder="Search"
            type="search"
          />
        )}
      </div>
      {isNotificationVisible ? (
        <Notification
          color={notification.type === "error" ? "danger" : "success"}
          isOpen={isNotificationVisible}
          toggle={() => setIsNotificationVisible(false)}
        >
          {notification.message}
        </Notification>
      ) : isLoading ? (
        <CoreContainer height={isBrowser ? "70vh" : "50vh"}>
          <Spinner size="sm" style={{ margin: "auto" }}>
            Loading...
          </Spinner>
        </CoreContainer>
      ) : (
        data && (
          <DataTable
            highlightOnHover
            striped
            columns={columns[type]}
            data={data}
            pagination
            paginationPerPage={25}
          />
        )
      )}
    </div>
  );
};

export default PricingPage;
